<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Withdraw Funds</h4>
        <div class="text-muted small">Send money out from your wallet</div>
      </div>

      <div class="d-flex gap-2">
        <a class="btn btn-outline-primary btn-sm" [routerLink]="['/wallets/withdraw/beneficiaries', walletId]">
          Manage Beneficiaries
        </a>
        <a class="btn btn-outline-secondary btn-sm" [routerLink]="['/wallets/manage', walletId]">
          Back
        </a>
      </div>
    </div>

    <div *ngIf="loading" class="card shadow-sm border-0">
      <div class="card-body py-4 text-center">
        <div class="spinner-border spinner-border-sm me-2"></div>
        Loading withdrawal form...
      </div>
    </div>

    <div class="alert alert-danger d-flex align-items-start gap-2" *ngIf="pageBlocker">
      <div>
        <div class="fw-bold">Withdrawal temporarily unavailable</div>
        <div>{{ pageBlocker }}</div>
        <div class="small mt-1 text-muted" *ngIf="pageBlockerCode">
          Code: {{ pageBlockerCode }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="!loading && config">
      <div *ngIf="showValidationSummary && validationSummary.length" class="alert alert-danger">
        <div class="fw-semibold mb-1">Please fix the following:</div>
        <ul class="mb-0 ps-3">
          <li *ngFor="let msg of validationSummary">{{ msg }}</li>
        </ul>
      </div>

      <div class="card shadow-sm border-0 mb-3">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <div class="text-muted small">Currency</div>
              <div class="fw-semibold">
                {{ config.currency.code }} - {{ config.currency.name }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Minimum withdrawal</div>
              <div class="fw-semibold">
                {{ config.minWithdraw | smartAmount:config.currency.symbol }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Wallet Balance</div>
              <div class="fw-semibold">
                {{ walletBalance | smartAmount:config.currency.symbol }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Available Balance</div>
              <div class="fw-semibold text-success">
                {{ availableBalance | smartAmount:config.currency.symbol }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0 mb-3" *ngIf="walletData">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="fw-bold">Withdrawal Limits</div>
          </div>

          <hr class="my-3">

          <div class="d-flex justify-content-between mb-2">
            <div class="text-muted small">Transaction Limit</div>
            <div class="fw-semibold">
              {{ getLimitData(walletData.tierInfo, 'Withdrawal', 'perTransactionLimit') || 0 |
              smartAmount:config.currency.symbol }}
            </div>
          </div>

          <div class="d-flex justify-content-between mb-2"
            *ngIf="getLimitData(walletData.tierInfo, 'Withdrawal', 'dailyLimit') > 0">
            <div class="text-muted small">Daily Limit</div>
            <div class="fw-semibold">
              {{ getLimitData(walletData.tierInfo, 'Withdrawal', 'remainingDailyLimit') || 0 |
              smartAmount:config.currency.symbol }}
              /
              {{ getLimitData(walletData.tierInfo, 'Withdrawal', 'dailyLimit') || 0 | smartAmount:config.currency.symbol
              }}
            </div>
          </div>

          <div class="d-flex justify-content-between mb-2"
            *ngIf="getLimitData(walletData.tierInfo, 'Withdrawal', 'monthlyLimit') > 0">
            <div class="text-muted small">Monthly Limit</div>
            <div class="fw-semibold">
              {{ getLimitData(walletData.tierInfo, 'Withdrawal', 'remainingMonthlyLimit') || 0 |
              smartAmount:config.currency.symbol }}
              /
              {{ getLimitData(walletData.tierInfo, 'Withdrawal', 'monthlyLimit') || 0 |
              smartAmount:config.currency.symbol }}
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="text-muted small">Remaining Available by KYC</div>
            <div class="fw-semibold">
              {{ remaining || 0 | smartAmount:config.currency.symbol }}
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0 mb-3" *ngIf="beneficiaries.length">
        <div class="card-body">
          <h6 class="fw-bold mb-3">Saved Beneficiaries</h6>

          <div class="row g-2">
            <div class="col-md-8">
              <select class="form-select" [(ngModel)]="selectedBeneficiaryId" [ngModelOptions]="{standalone: true}"
                name="selectedBeneficiaryId">
                <option value="">Select saved beneficiary</option>
                <option *ngFor="let item of beneficiaries" [value]="item.id">
                  {{ item.nickname || 'Beneficiary' }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <button class="btn btn-outline-primary w-100" type="button" (click)="useSelectedBeneficiary()"
                [disabled]="!selectedBeneficiaryId">
                Load Beneficiary
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-success mb-3" *ngIf="beneficiaryMode && selectedBeneficiary as beneficiary">

        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
            <div>
              <div class="d-flex align-items-center gap-2 mb-1">
                <h6 class="fw-bold mb-0">Using Saved Beneficiary</h6>

                <span class="badge text-bg-success">
                  Selected
                </span>
              </div>

              <div class="text-muted small">
                {{ beneficiary.nickname || 'Beneficiary' }}

              </div>
            </div>

            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="clearSelectedBeneficiary()">
              Change Beneficiary
            </button>
          </div>

          <hr class="my-3">

          <div class="row g-3">
            <div class="col-md-6" *ngFor="let item of beneficiaryPreviewEntries(beneficiary)">

              <div class="text-muted small">
                {{ pretty(item.key) }}
              </div>

              <div class="fw-semibold text-break">
                {{ item.value || '-' }}
              </div>
            </div>
          </div>

          <div class="alert alert-success py-2 px-3 small mt-3 mb-0">
            The saved destination details will be used for this withdrawal.
            You only need to enter the withdrawal amount.
          </div>
        </div>
      </div>

      <form [formGroup]="form" novalidate>
        <div class="card shadow-sm border-0 mb-3">
          <div class="card-body">
            <h6 class="fw-bold mb-3">Withdrawal Details</h6>

            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Amount</label>
                <input #amountInput type="number" class="form-control" formControlName="amount" step="0.01"
                  placeholder="Enter amount" />
                <div class="text-danger small mt-1"
                  *ngIf="(form.get('amount')?.touched || form.get('amount')?.dirty) && form.get('amount')?.errors">
                  <div *ngIf="form.get('amount')?.errors?.['required']">
                    Amount is required.
                  </div>

                  <div *ngIf="form.get('amount')?.errors?.['min']">
                    Minimum withdrawal is
                    {{ (config.minWithdraw || walletData.currencyRules.minWithdraw || 0) |
                    smartAmount:config.currency.symbol }}.
                  </div>

                  <div *ngIf="form.get('amount')?.errors?.['max']">
                    Maximum allowed withdrawal is
                    {{ maxWithdrawableAmount | smartAmount:config.currency.symbol }}.
                  </div>
                </div>
                <div class="form-text">
                  Available to withdraw:
                  <strong>{{ maxWithdrawableAmount | smartAmount:config.currency.symbol }}</strong>
                </div>
              </div>

            </div>
          </div>
        </div>
      </form>

      <form [formGroup]="destinationForm" novalidate *ngIf="!beneficiaryMode">
        <div class="card shadow-sm border-0 mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="fw-bold mb-0">Destination Details</h6>

              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="resolveDestination()"
                [disabled]="resolving || destinationForm.invalid">
                <span *ngIf="resolving" class="spinner-border spinner-border-sm me-2"></span>
                Resolve Account
              </button>
            </div>

            <div class="row g-3">
              <ng-container *ngFor="let field of config.fields">
                <div class="col-md-6" *ngIf="field.fieldType !== 'textarea'">
                  <label class="form-label">
                    {{ field.label }}
                    <span class="text-danger" *ngIf="field.isRequired">*</span>
                  </label>

                  <ng-container [ngSwitch]="field.fieldType">
                    <ng-container *ngSwitchCase="'select'">
                      <div *ngIf="field.fieldKey === 'bankCode'" class="mb-2">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text">Search</span>
                          <input type="text" class="form-control" [value]="bankSearch"
                            (input)="onBankSearchChange($any($event.target).value)" placeholder="Type bank name" />
                          <button *ngIf="bankSearch" class="btn btn-outline-secondary" type="button"
                            (click)="clearBankSearch()">
                            Clear
                          </button>
                        </div>
                        <div class="text-muted small mt-1">
                          {{ getBankOptionCount() }} bank(s) found
                        </div>
                      </div>

                      <select class="form-select" [formControlName]="field.fieldKey">
                        <option value="">{{ field.placeholder || ('Select ' + field.label) }}</option>
                        <option *ngFor="let opt of getFilteredOptions(field)" [value]="opt.value">
                          {{ opt.label }}
                        </option>
                      </select>
                    </ng-container>

                    <input *ngSwitchCase="'number'" class="form-control" type="number"
                      [placeholder]="field.placeholder || ('Enter ' + field.label)" [formControlName]="field.fieldKey"
                      [readonly]="isReadonly(field)" />

                    <input *ngSwitchCase="'email'" class="form-control" type="email"
                      [placeholder]="field.placeholder || ('Enter ' + field.label)" [formControlName]="field.fieldKey"
                      [readonly]="isReadonly(field)" />

                    <input *ngSwitchDefault class="form-control" type="text"
                      [placeholder]="field.placeholder || ('Enter ' + field.label)" [formControlName]="field.fieldKey"
                      [readonly]="isReadonly(field)" />
                  </ng-container>

                  <div class="text-muted small mt-1" *ngIf="field.helpText">
                    {{ field.helpText }}
                  </div>

                  <div class="text-danger small mt-1" *ngIf="isInvalid(field.fieldKey, 'destination')">
                    {{ getErrorText(field) }}
                  </div>
                </div>

                <div class="col-12" *ngIf="field.fieldType === 'textarea'">
                  <label class="form-label">
                    {{ field.label }}
                    <span class="text-danger" *ngIf="field.isRequired">*</span>
                  </label>

                  <textarea class="form-control" rows="3" [placeholder]="field.placeholder || ('Enter ' + field.label)"
                    [formControlName]="field.fieldKey" [readonly]="isReadonly(field)"></textarea>

                  <div class="text-muted small mt-1" *ngIf="field.helpText">
                    {{ field.helpText }}
                  </div>

                  <div class="text-danger small mt-1" *ngIf="isInvalid(field.fieldKey, 'destination')">
                    {{ getErrorText(field) }}
                  </div>
                </div>
              </ng-container>
            </div>



            <div class="border-top mt-4 pt-3" [formGroup]="form">
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" formControlName="saveBeneficiary"
                      id="saveBeneficiary">

                    <label class="form-check-label" for="saveBeneficiary">
                      Save as beneficiary
                    </label>
                  </div>
                </div>

                <div class="col-md-6" *ngIf="form.value.saveBeneficiary">
                  <label class="form-label">Beneficiary Nickname</label>
                  <input type="text" class="form-control" formControlName="beneficiaryNickname"
                    [placeholder]="getBeneficiaryDefaultNickname() || 'e.g. My bank account'">
                </div>
              </div>
            </div>

            <div class="text-danger small mt-2" *ngIf="destinationForm.errors?.['accountNumberMismatch']">
              Account number and confirmation do not match.
            </div>

            <div class="alert alert-info mt-3 mb-0" *ngIf="resolving">
              Resolving account details...
            </div>

            <div class="alert alert-success mt-3 mb-0" *ngIf="resolveSuccess && !resolving">
              {{ resolveSuccess }}
            </div>

            <div class="alert alert-danger mt-3 mb-0" *ngIf="resolveError && !resolving">
              {{ resolveError }}
            </div>
          </div>
        </div>
      </form>

      <div class="d-flex justify-content-end">
        <button class="btn btn-primary w-100 mt-4" type="button" [disabled]="submitting || !canContinue()"
          (click)="continue()">
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-2"></span>
          {{ submitting ? 'Getting quote...' : 'Continue' }}
        </button>
      </div>

      <app-support-context-card type="withdrawal" title="Need help with withdrawals?"
        subtitle="Get quick answers about payout status, delays, and failed withdrawals.">
      </app-support-context-card>
    </ng-container>

    <app-footer></app-footer>
  </main>
</div>